import RegisterStep from "./RegisterStep";

const HandleRenderDiv = ({ pagename, startStep, backToLogin, onClose }) => {
  return (
    <RegisterStep
      initialStep={startStep}
      backToLogin={backToLogin}
      onClose={onClose}
    />
  );
};

export default HandleRenderDiv;
